export default function PhotoViewListCtrl() {
  var ctrl = this;

  ctrl.updateActiveElements = function () {
    ctrl.activeNavIndex = 0;
    ctrl.activeItemIndex = 0;
  };
}